function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.90368 4.59312L6.00669 2.49012V9.03481C6.00669 9.26705 6.13046 9.4815 6.33156 9.59753C6.53255 9.71372 6.78035 9.71372 6.98134 9.59753C7.18245 9.48148 7.30622 9.26705 7.30622 9.03481V2.49012L9.40923 4.59312C9.52703 4.7296 9.69626 4.81104 9.87631 4.81789C10.0565 4.82474 10.2315 4.75638 10.3592 4.62936C10.4871 4.50222 10.5563 4.32776 10.5506 4.14758C10.5448 3.96739 10.4643 3.79777 10.3286 3.67912L6.65647 0L2.98437 3.67912C2.82012 3.84337 2.75598 4.0827 2.81613 4.3071C2.87615 4.53137 3.05149 4.7067 3.27576 4.76672C3.50016 4.82687 3.7395 4.76274 3.90374 4.59849L3.90368 4.59312Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.4117 7.96363C12.2391 7.96401 12.0736 8.03287 11.9515 8.15491C11.8294 8.27706 11.7606 8.44256 11.7602 8.61517V10.6985H1.5523V8.62053C1.56164 8.44208 1.49739 8.26763 1.37436 8.13798C1.25132 8.00822 1.08035 7.93488 0.90166 7.93488C0.72297 7.93488 0.551983 8.00822 0.428963 8.13798C0.30593 8.26761 0.241551 8.44207 0.250891 8.62053V12H13.0617V8.62053C13.063 8.44718 12.9953 8.28032 12.8733 8.15691C12.7513 8.03363 12.5852 7.96402 12.4117 7.96365L12.4117 7.96363Z",
  fill: "black"
});

var SvgUpload = function SvgUpload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUpload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/upload.64c6a8e5.svg";
export { ForwardRef as ReactComponent };